/* eslint-disable @typescript-eslint/no-explicit-any */
import { ValueOf } from '@client/new/helpers/types';
import { v4 } from 'uuid';

import {
  ClientSession,
  ClientSessionEvent,
  EventMeta,
} from './sessionTracker.domain';
import { loggerSessionSubscriber } from './subscribers/LoggerSessionSubscriber';
import { openSearchSessionSubscriber } from './subscribers/OpenSearchSessionSubscriber';
import { sentrySessionSubscriber } from './subscribers/SentrySubscriber';

let eventCounter = 0;

export const trackSessionEvent = <T extends ClientSessionEvent['type']>(
  type: T,
  value: ValueOf<ClientSessionEvent, T>,
) => {
  try {
    const meta: EventMeta = {
      date: new Date().toISOString(),
      pathname: window.location.pathname,
      id: eventCounter++,
    };

    if ((value as any).testId === undefined) delete (value as any)['testId'];
    const event = { type, value, meta } as ClientSessionEvent;

    switch (event.type) {
      case 'Login': {
        session.userEmail = event.value.userEmail;
        session.userId = event.value.userId;
        session.influencerId = event.value.influencerId;
        break;
      }
      case 'ImpersonateCreator': {
        session.influencerId = event.value.influencerId;
        break;
      }
    }
    session.events.push(event);
    _subscribers.forEach((s) => s.onEvent(event));
  } catch (err) {
    console.error('Failed to track session event:', err);
  }
};

const session: ClientSession = {
  createdAt: new Date().toISOString(),
  url: window.location.origin,
  events: [],
  sessionId: v4(),
};

let _subscribers: Array<SessionSubscriber> = [];

export type SessionSubscriber = {
  name: string;
  onInit: (session: ClientSession) => void;
  onEvent: (v: ClientSessionEvent) => void;
  sync: () => Promise<void>;
};

export const register = (subscriber: SessionSubscriber) => {
  console.info(`SessionTracker: Registering ${subscriber.name}`);
  _subscribers.push(subscriber);
  subscriber.onInit(session);
  session.events.forEach((e) => subscriber.onEvent(e));
};

export const unregister = (name: string) => {
  _subscribers = _subscribers.filter((s) => s.name !== name);
};

export const getSessionId = () => session.sessionId;
export const getEventsCount = () => eventCounter;
export const getSessionEvents = () => session.events;

export const syncSubscribers = () =>
  Promise.all(_subscribers.map((s) => s.sync()));

export const registerSessionSubscribers = () =>
  [
    loggerSessionSubscriber,
    openSearchSessionSubscriber,
    sentrySessionSubscriber,
  ].forEach(register);
